<template>
  <div class="home">
    <h1>Help!</h1>

    <h3>Asking for Help</h3>
    <b style="color:purple">First, try <a style="color:purple;text-decoration:underline" href="https://piazza.com/mines/spring2022/csci262" target="_blank">Piazza</a>!</b><br/>
    <b style="color:red; ">First, try <a style="color:red;text-decoration:underline" href="https://piazza.com/mines/spring2022/csci262" target="_blank">Piazza</a>!</b><br/>
    <b style="color:green;">First, try <a style="color:green;text-decoration:underline" href="https://piazza.com/mines/spring2022/csci262" target="_blank">Piazza</a>!</b><br/>
    <p>You might get help fastest via a classmate on Piazza. Your instructors will be looking at
      Piazza, too, and will usually respond fairly quickly. When you post on Piazza, please do not
      post complete programs or solutions; try to ask or answer questions without code first, or use
      only the smallest amount of code necessary to get your question or point across. You can also
      post code <i>private to instructors</i> on Piazza.  We'll talk in class about
      <i>incremental development</i> of your code, which should help keep things in small chunks.</p>
    <p>Once you've tried Piazza, if you still have questions, you can contact your instructor directly
      for help. You should also feel free to contact your instructor at anytime about any concerns which
      you aren't comfortable sharing on Piazza.</p>
    <p><b>Looking for office hours?</b> - these are posted on the <router-link to="/">home page</router-link>.</p>

    <h3>References</h3>
    <p>Here are some websites to keep handy while you are programming:</p>
    <ul>
        <li><a href="http://cplusplus.com" target="_blank">cplusplus.com</a></li>
        <li><a href="http://cppreference.com" target="_blank">cppreference.com</a></li>
    </ul>

    <h3>Getting Started with C++</h3>
    <ul>
        <li>Your textbook this semester is a comprehensive C++ textbook and covers all material covered in CSCI 261, in case you are new to C++, or just need a refresher.</li>
        <li><a href="resources/cpp_tutorial.html" target="_blank">C++ tutorial for Java programmers</a></li>
    </ul>

    <h3>Practice Problems</h3>
    <p>Need more practice, or just want to challenge yourself?  Try <a href="https://open.kattis.com/" target="_blank">Kattis!</a></p>

    <h3><a id="clionfaq"></a>CLion FAQ</h3>
    <dl>
        <dt><b>Do I have to use CLion?</b></dt>
        <dd>No, you can use any IDE or compilation environment you are comfortable with; however, we
          may be unable to help you if you run into trouble with an IDE other than CLion.  Also, assignments will be graded using the g++ compiler on Windows (MinGW distribution, g++ version 7, which is installed on the lab computers); it is very common for C++ code to compile and work on one compiler/platform, but not on another.  When in doubt, test your code on the school computers!</dd>
        <br/>

        <dt><b>How do I get CLion on my personal machine?</b></dt>
        <dd>
          <ol>
            <li>You must first create a free student account with JetBrains at <a href="https://www.jetbrains.com/student" target="_blank">https://www.jetbrains.com/student</a>. If you created a student account previously (e.g., in CSCI 261), it should still work.</li>
            <li>Next, install a compiler (if not already installed).  The steps to do this depend on your operating system:
              <ul>
                <li>Windows: Download <a href="resources/mingw64.7.3.0.zip">MinGW</a>. Open the zip
                file and drag the mingw64 folder to the root of your C: drive.</li>
                <li>Mac OS X: Install XCode from the Mac App Store.</li>
                <li>Linux: Depending on your distribution, you may already have g++ installed.
                  (You can find out by trying the command 'g++' at a command prompt.) If not, use your
                  package manager to install the latest g++ package available on your distribution.</li>
              </ul>
            </li>
            <li>After installing a compiler, you can proceed to install CLion from
            <a href="https://www.jetbrains.com/clion/download" target="_blank">https://www.jetbrains.com/clion/download</a>.
            (If you previously installed CLion, you can keep using the version you installed previously, or you
            can update to the latest. Either is fine.)</li>
          </ol>
        </dd>
        <br/>

        <dt><b>What is the CMakeLists.txt file, and what should be in it?</b></dt>
        <dd>CMakeLists.txt is a file that instructs CLion (really, a helper program named "cmake")
          how to build your program from source files.  The file can get pretty complex, but for this
          course, your CMakeLists.txt should contain something like this:</dd>
<pre>
          cmake_minimum_required(VERSION 3.0)
          project(myprogram)

          set(CMAKE_CXX_STANDARD 11)

          include_directories(.)

          add_executable(myprogram
              source1.cpp
              source2.cpp
              header1.h)
</pre>
    <dd>While CLion will usually create and manage CMakeLists.txt for you, there are many ways you might add a file to your project or remove a file from the project such that CMakeLists.txt doesn't get properly updated.  To fix this, edit the list of files in the "add_executable()" portion of the file - inside the parentheses, the first argument needs to match the project name (set above using project()), the rest are your source and header files.</dd>
        <br/>
	<dt><b>CLion is giving me an "undefined references" error or similar.  What's wrong?</b></dt>
        <dd>This means that the compiler can't find the class/function/constant/variable you are looking for. This is usually a problem of not including the proper references to the files/libraries being used. The solution is one of two things:</dd>
<ol>
	<li>Header (.h) files should be included in other cpp/header files in which their classes/functions are referenced</li>
	<li>All cpp files for the project should be listed in the add_executable line for the CMakeLists.txt. See above</li>
</ol>
 <dt><b>CLion is telling me that "This file does not belong to any project target" or similar.  What's wrong?</b></dt>
        <dd>This can happen if you add files to your project through some mechanism other than through CLion's interface (e.g., copying the file into the project directory using File Explorer).  You need to make sure all of your source files are listed in the CMakeLists.txt file. See above.</dd>
        <br/>

<dt><b>The starter code doesn't have a CMakeLists.txt or I want to create a project from sources </b></dt>
<dd>In general, if you want to create a project from .cpp and .h files that you may have downloaded or worked on previously, CLion provides methods to bring these files into a project so you can run them.  </dd>
<ol>
	<li> First, ensure that all  files you want to be a part of the project are in a seperate folder </li>
	<li> Then, in CLion, select <b>File>New Project</b>. In the Location field, navigate to the folder with all of your files. Now click "Create". CLion should recognize that this folder doesn't contain a CMake project, and will ask you if you want to "Create from Existing Sources". Select this option </li>
	<li> CLion will then generate the necessary files to turn this folder into a CMake project. As a final step, make sure that all source files are listed in the CMakeLists.txt file. See above </li>
</ol>

<dd> Note: Some older versions of CLion have a <b>File>Import/Create Project from Existing Sources</b> command. If you see this, you can use this tool in much the same way as the method described above. When prompted to open a folder, open the folder with your files, and then select all of the files you want to bring into the project. As always, make sure to drag-and-drop any files you need to access in your code as I/O (like dictionary.txt) into the cmake-build-debug folder. </dd>
<br/>

        <dt><b>Why am I getting the error message "CMake Error at CMakeLists.txt:1 (cmake_minimum_required):
  CMake 3.<i>nn</i> or higher is required.  You are running version 3.<i>mm</i>"?</b></dt>
        <dd>Most likely you created your project under a newer version of CLion, and are now trying to use it under an older version.  Just modify the "cmake_minimum_required" line in CMakeLists.txt to </dd>
<pre>
          cmake_minimum_required(VERSION 3.0)
</pre>
        <dd>and you should be fine.</dd>
        <br/>
        <dt><b>My program is not printing anything from cout, or is only printing part of what I was expecting.</b></dt>
        <dd>If you are on Windows, this may be a known issue.  To fix it, on the top menus in CLion, select Help > Find Action. Search for "registry" and hit enter. Uncheck the box that says <code>run.processes.with.pty</code>.  If you are on a campus lab machine, you may need to do this every time you run CLion.  Sorry!</dd>
        <br/>
        <dt><b>I'm getting a message, "Cannot continue with sh.exe on your path" or similar.</b></dt>
        <dd>This seems to happen somewhat randomly on the campus lab machines.  It is some kind of conflict with other software installed on the machine, but doesn't happen consistently.  If/when it happens, do the following steps to work around the problem:</dd>
        <ol>
<li>Go to File > Preferences</li>
<li>Expand Build, Execution, Deployment</li>
<li>Select CMake</li>
<li>In the CMake options: field, enter <code>-DCMAKE_SH="CMAKE_SH-NOTFOUND"</code></li>
<li>Hit Apply and Ok</li>
        </ol>
        <br/>
        <dt><b>CLion won't compile my project, and nothing above fixed my problem.</b></dt>
        <dd>We've seen some instances where the CLion project files just seem to get corrupted, and CLion just won't build your project.  This seems to happen most often when working over the network or with a flash drive.  If you are completely stuck, there are a couple of ways to potentially get back on track.  The easiest way is to close CLion, go to your project folder, and delete the "cmake-build-debug" and ".idea" folders.  Restart CLion and re-open your project folder.  CLion will create fresh versions of the deleted folders, and hopefully everything will start working again.  Alternately, you can create a new project and copy your old source files into it - just be sure to edit your CMakeLists.txt file when you do this!</dd>
        <br/>
    </dl>

  </div>
</template>

<script>
export default {
  name: 'Help'
}
</script>
